const useBrowserfunctions = function () {

  /*
  * loop door de browser voorkeuren heen en kijk of je een taal tegenkomt die meedoet.
  * Als geen enkele browsertaal gevonden wordt dan terugvallen op de fallback taal
  *
  * @param
  * */
  const selectLanguageWithFallback = function (candidates, fallback) {
    let languagePreferences = navigator.languages

    let langPreferred, langCandidate
    for (langPreferred of languagePreferences) {
      for (langCandidate of candidates) {
        if (langPreferred.indexOf(langCandidate) !== -1) {
          return langCandidate
        }
      }
    }

  }

  return { selectLanguageWithFallback }
}

export { useBrowserfunctions }
